import { useTranslation } from "../internationalisation/translation.hook";
import { ErrorPage } from "./ErrorPage";

export const NotFoundPage = () => {
    const { t } = useTranslation();

    return <ErrorPage message={t("NotFoundPage: page-not-found-message")} />
};
